import React, { Component } from 'react'
import { get } from "lodash"

import { checkIsValidHelp } from "./static.helpData"
import { withStepsState } from "../../../shared/containers/containerStepsState"
import ButtonFill from "../../../shared/items/controls/buttonFill"
import STEPS_NAMES_BY_KEY from './../../../utils/stepsNamesByKey'

class HelpNextStepButton extends Component {
  constructor() {
    super();

    this.goNext = this.goNext.bind(this);
  }

  goNext() {
    this.props.onToNextStep();

    let help = [];

    if (this.props.data.help.appleRings) help.push('Apple Activity rings');
    if (this.props.data.help.guidelines) help.push('Coach\'s guidelines');
    if (this.props.data.help.seeing) help.push('Seeing my body change');
    if (this.props.data.help.supportive) help.push('Supportive community');
    if (this.props.data.help.tips) help.push('Healthy lifestyle tips');
    if (this.props.data.help.training) help.push('Training progress');

    window.dataLayer.push({
      'event': 'onboarding_question',
      'quiz_question': STEPS_NAMES_BY_KEY['help'],
      'quiz_answer': help,
    });
  }

  componentDidUpdate() {
    const { data, onSetSuccessValidate, onSetFailValidate } = this.props

    if (checkIsValidHelp(data) && !get(data, ["help", "isValid"], false))
      onSetSuccessValidate("help")

    if (!checkIsValidHelp(data) && get(data, ["help", "isValid"], false))
      onSetFailValidate("help")
  }

  render() {
    const { data, onToNextStep } = this.props

    return (
      <ButtonFill disabled={!get(data, ["help", "isValid"], false)} onClick={this.goNext}>
        {this.props.children}
      </ButtonFill>
    )
  }
}

export default withStepsState(HelpNextStepButton)